<div class="flex flex-col gap-4">
  <!-- dropzone -->
  <div
    class="border rounded-lg p-6 flex flex-col items-center gap-3 transition-colors"
    [ngClass]="
      dropEnabled()
        ? 'border-primary dark:border-primary-darkmode bg-primary-soft dark:bg-primary-soft-darkmode'
        : 'border-outline dark:border-outline-darkmode border-dashed bg-surface dark:bg-surface-darkmode'
    "
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    @if (dropEnabled()) {
      <div class="text-primary dark:text-primary-darkmode">
        <ng-icon name="heroArrowUturnDown" size="32" class="!block" />
      </div>
    } @else {
      <div class="text-on-surface-variant dark:text-on-surface-variant-darkmode">
        <ng-icon name="heroArrowUpTray" size="32" class="!block" />
      </div>
    }

    <div class="text-sm flex flex-col items-center text-center gap-1">
      <!-- dropzone title -->
      @if (dropEnabled()) {
        <p class="font-semibold empty:hidden">
          <ng-content select="[slot=dragover-title]" />
        </p>
      } @else {
        <p class="font-semibold empty:hidden">
          <ng-content select="[slot=title]" />
        </p>
      }
      <!-- dropzone subtitle -->
      <p class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode empty:hidden">
        <ng-content select="[slot=subtitle]" />
      </p>
    </div>
  </div>

  <!-- file list -->
  <div class="flex flex-col gap-2 empty:hidden">
    <ng-content select="ui-dropzone-file,[slot=file-list]" />
  </div>
</div>
